import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  main: {
    width: '100%',
    padding: '20px 40px',
    gap: '15px',
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('600')]: {
      padding: '20px 16px',
    },
  },

  header: {
    flex: 1,
  },

  title_header: {
    color: "#535758",
    fontWeight: 500,
    fontSize: 'calc(24px + (8/1200) * 100 * 1vw)'
  },

  balance: {
    width: "100%",
    justifyContent: "space-between",
    borderRadius: "8px",
    backgroundColor: "#fff",
    display: "flex",
    textAlign: "center",

    [theme.breakpoints.down('xs')]: {
      flexWrap: "wrap",
    }
  },

  account_information: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 10px",
    borderRadius: "8px",
    color: "#fff",
    backgroundColor: "#88bd3f",

    [theme.breakpoints.down('xs')]: {
      width: "100%",
    },

    "& span": {
      fontWeight: "bold",
    }
  },

  balance_value: {
    flexGrow: "1",
    display: "flex",

    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "15px",
    color: "#505367",

    "& span": {
      fontWeight: "bold",
      fontSize: 'calc(22px + (34 - 22) * ((100vw - 300px) / (1600 - 300)))',

      "& small": {
        fontSize: "15px",
        marginRight: "8px"

      }
    },

    "& p": {
      fontWeight: "bold",
      fontSize: 'calc(10px + (14 - 10) * ((100vw - 300px) / (1600 - 300)))',
    }
  },

  available_text: {
    color: "#88bd3f",
  },

  button_withdrawl: {
    width: "160px",
    display: "flex",
    alignItems: "center",
    padding: "20px",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: "8px",
    backgroundColor: "#00619e",
    color: "#fff",
    cursor: "pointer",
    fontSize: '12px',

    [theme.breakpoints.down('xs')]: {
      width: "100%",
    },

    "&:hover": {
      opacity: "0.8",
    },

    "&:disabled": {
      backgroundColor: "grey",
      cursor: "not-allowed",

      "&:hover": {
        opacity: "1",
      },
    }
  },

  // Ocupa o lugar do antigo botão de saque manual, agora que o saque é automático.
  withdrawl_notice: {
    width: "220px",
    display: "flex",
    alignItems: "center",
    padding: "20px",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: "8px",
    backgroundColor: "#e8f1f8",
    border: "1px solid #b8d4e8",
    color: "#00619e",
    fontSize: "12px",
    textAlign: "center",
    lineHeight: "16px",

    [theme.breakpoints.down('xs')]: {
      width: "100%",
    },

    "& span": {
      marginTop: "8px",
    },
  },

  transaction_type: {
    display: "flex",
  },

  table: {
  },

  disablePlan: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '20px',
  },

  disableTitle: {
    marginBottom: '20px',
  },

  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  bgStatusError: {
    color: '#EC5350',
    fontWeight: 'bold',
  },

  bgStatusPrimary: {
    color: '#2E7C33',
    fontWeight: 'bold',
  },

  mainHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px'
  },
  search: {
    background: '#ffffff',
    width: '100%'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 190,

    [theme.breakpoints.down('600')]: {
      width: '100%'
    },
  },
  alert: {
    width: '100%',
  },
  filterList: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row-reverse',
    alignItems: 'center',

    [theme.breakpoints.down('600')]: {
      flexDirection: 'column-reverse'
    },
  },
  divider: {
    marginBottom: '25px',
  },
  title: {
    fontWeight: 600,
    color: '#535758',
    marginTop: '15px',
  },
  refresh: {
    [theme.breakpoints.down(600)]: {
      padding: '10px 0px 0px'
    },
  },
  loadMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 0',
  },
}));
